// extracted by mini-css-extract-plugin
export var arrow = "_2c-6";
export var changeItem = "_2c-3";
export var changesHeader = "_2c-1";
export var changesList = "_2c-2";
export var container = "_2c-0";
export var pathLabel = "_2c-4";
export var value = "_2c-7";
export var valuesContainer = "_2c-5";